module.exports = __webpack_public_path__ + "img/20210422.65777bb1.gif";